import { render, staticRenderFns } from "./CreateEventSeries.vue?vue&type=template&id=2427ec6a"
import script from "./CreateEventSeries.vue?vue&type=script&lang=js"
export * from "./CreateEventSeries.vue?vue&type=script&lang=js"
import style0 from "./CreateEventSeries.vue?vue&type=style&index=0&id=2427ec6a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2427ec6a')) {
      api.createRecord('2427ec6a', component.options)
    } else {
      api.reload('2427ec6a', component.options)
    }
    module.hot.accept("./CreateEventSeries.vue?vue&type=template&id=2427ec6a", function () {
      api.rerender('2427ec6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CreateEventSeries.vue"
export default component.exports